<!-- <div #reportContainer class="report-container" style="height: 500px; width: 100%;">
    <powerbi-report class="report-container" [embedConfig]="embedConfig">
    </powerbi-report>
</div>
<div class="buttonRef">
    <button class="btn btn-primary m-left" (click)="refreshReport()">Actualizar Datos</button>
</div>  -->

<div class="powerbi-container">
    <iframe src="https://app.powerbi.com/reportEmbed?reportId=30e54cf7-a5d0-401f-84f3-7bc257b6da8d&autoAuth=true" frameborder="0" allowFullScreen="true"></iframe>
</div>
